/**
 * Formats a number or BigInt to a string with B, M, or k suffix
 * @param {number|BigInt} value - The number to format
 * @returns {string} Formatted number with appropriate suffix
 */
function formatNumberM(value) {
  // Handle different input types
  const isNegative = typeof value === 'bigint' 
    ? value < 0n 
    : value < 0;
  
  // Convert to absolute value for calculations
  const absValue = isNegative 
    ? (typeof value === 'bigint' ? -value : -value) 
    : value;
  
  let numValue;
  let suffix = '';
  
  if (typeof absValue === 'bigint') {
    // Handle BigInt values
    if (absValue >= 1000000000n) {
      numValue = Number(absValue / 1000000000n) + Number(absValue % 1000000000n) / 1000000000;
      suffix = 'B';
    } else if (absValue >= 1000000n) {
      numValue = Number(absValue / 1000000n) + Number(absValue % 1000000n) / 1000000;
      suffix = 'M';
    } else if (absValue >= 1000n) {
      numValue = Number(absValue / 1000n) + Number(absValue % 1000n) / 1000;
      suffix = 'k';
    } else {
      numValue = Number(absValue);
    }
  } else {
    // Handle regular numbers
    if (absValue >= 1000000000) {
      numValue = absValue / 1000000000;
      suffix = 'B';
    } else if (absValue >= 1000000) {
      numValue = absValue / 1000000;
      suffix = 'M';
    } else if (absValue >= 1000) {
      numValue = absValue / 1000;
      suffix = 'k';
    } else {
      numValue = absValue;
    }
  }
  
  // Format with reasonable decimal places
  // For larger numbers, show fewer decimal places
  let formattedValue;
  if (numValue >= 100) {
    formattedValue = numValue.toFixed(1);
  } else if (numValue >= 10) {
    formattedValue = numValue.toFixed(2);
  } else {
    formattedValue = numValue.toFixed(3);
  }
  
  // Remove trailing zeros after decimal point
  formattedValue = formattedValue.replace(/\.0+$/, '').replace(/(\.\d*[1-9])0+$/, '$1');
  
  // Add negative sign if needed
  return (isNegative ? '-' : '') + formattedValue + suffix;
}

module.exports = {
  formatNumberM
};
